/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreRegistrationDto } from '../../models/pre-registration-dto';
import { UpdatePreRegistrationDto } from '../../models/update-pre-registration-dto';

export interface PreRegistrationControllerUpdateV1$Params {
  id: string;
      body: UpdatePreRegistrationDto
}

export function preRegistrationControllerUpdateV1(http: HttpClient, rootUrl: string, params: PreRegistrationControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PreRegistrationDto>> {
  const rb = new RequestBuilder(rootUrl, preRegistrationControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PreRegistrationDto>;
    })
  );
}

preRegistrationControllerUpdateV1.PATH = '/api/v1/pre-registration/{id}';
